import React from 'react';
import { Box, Checkbox, CheckboxProps, FormError } from 'pounceV2';
import { FieldConfig, useField } from 'formik';
import { safeguardErrorMsg } from '../utils';

const FormikCheckboxV3: React.FC<CheckboxProps & Required<Pick<FieldConfig, 'name'>>> = props => {
  const { onChange: onChangeProp, ...rest } = props;
  const [field, meta, helpers] = useField(props.name);

  const isInvalid = meta.touched && !!meta.error;
  const errorElementId = isInvalid ? `${props.name}-error` : undefined;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    helpers.setValue(checked);
    onChangeProp?.(event, checked);
  };

  return (
    <Box>
      <Checkbox
        size="small"
        {...rest}
        checked={!!field.value}
        onChange={handleChange}
        invalid={isInvalid}
        aria-describedby={isInvalid ? errorElementId : undefined}
      />
      {isInvalid && <FormError id={errorElementId}>{safeguardErrorMsg(meta.error)}</FormError>}
    </Box>
  );
};

export default FormikCheckboxV3;
